import { api } from "@/config/api-fetch";
import { useQuery } from "@tanstack/react-query";

export type UsageStats = {
    chatbot: { count: number; limit: number };
    bulk_rewrite: { count: number; limit: number };
    forum_conversion: { count: number; limit: number };
    forum_answer: { count: number; limit: number };
    search_block: { count: number; limit: number };
};

export function useUsageStats() {
    const query = useQuery({
        queryKey: ["usage-stats"],
        queryFn: async () => api.get<UsageStats>("/usage-stats"),
    });

    return query;
}
